import { useEffectOnce } from 'react-use'

import { retryWithBackoff } from 'utils/retry'

export const FRESHDESK_ELEMENT_IDS = {
  scriptA: 'freshworks-script-a',
  scriptB: 'freshworks-script-b',
  container: 'freshworks-container',
  frame: 'freshworks-frame'
}

function freshworksWidgetWithRetry(...args) {
  return retryWithBackoff(
    100,
    2000,
    () =>
      window.FreshworksWidget && typeof window.FreshworksWidget === 'function',
    () => window.FreshworksWidget(...args)
  )
}

export function useHideFreshdeskWidget() {
  useEffectOnce(() => {
    freshworksWidgetWithRetry('hide', 'launcher')

    return () => {
      freshworksWidgetWithRetry('show', 'launcher')
    }
  })
}

/*
Note: https://gremlininc.atlassian.net/browse/EN-6016
This widget code is generated by an admin via Freshdesk's widget creator.

<script>
	window.fwSettings={
	'widget_id':151000001121
	};
	!function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()
</script>
<script type='text/javascript' src='https://widget.freshworks.com/widgets/151000001121.js' async defer></script>
 */
export const useMountFreshdeskWidget = ({ enabled = true } = {}) => {
  useEffectOnce(() => {
    if (!enabled) {
      /**
       * The Freshdesk widget has a11y violations that we can't fix, blocks notifications, etc
       * To disable in cypress tests, pass in { enabled: !Boolean(window.Cypress) }
       */
      return
    }

    const scriptA = document.createElement('script')
    scriptA.id = FRESHDESK_ELEMENT_IDS.scriptA
    scriptA.innerText =
      'window.fwSettings={\'widget_id\':151000001121};!function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()'
    document.body.appendChild(scriptA)

    const scriptB = document.createElement('script')
    scriptB.id = FRESHDESK_ELEMENT_IDS.scriptB
    scriptB.type = 'text/javascript'
    scriptB.src = 'https://widget.freshworks.com/widgets/151000001121.js'
    scriptB.async = true
    scriptB.defer = true
    document.body.appendChild(scriptB)

    /**
     * Widget will unmount on logout, for instance
     */
    return () => {
      freshworksWidgetWithRetry('destroy')
      Object.values(FRESHDESK_ELEMENT_IDS).forEach((selector) => {
        document.body
          .querySelectorAll(`#${selector}`)
          .forEach((node) => document.body.removeChild(node))
      })
    }
  })
}
